import React, { useMemo } from 'react';
import { getTypeClass } from '../utils';

const Badge = React.memo((props: {
  type: string;
  classType: string;
}) => {
  const { type, classType } = props;
  const typeClass = useMemo(
    () => getTypeClass(type),
    [type],
  );

  const badgeClassName = useMemo(
    () => `${classType} ${typeClass}`,
    [classType, typeClass],
  );
  return (
    <span className={badgeClassName}>
      {type}
    </span>
  );
});

export default Badge;
